import { gql, useQuery } from "@apollo/client";
import type { QueryHookOptions } from "@apollo/client";

const CheckSimilarProductsAvailable_Emerson_Query = gql`
  query CheckSimilarProductsAvailable_Emerson_Query($productId: ID!) {
    viewer {
      product: node(id: $productId) {
        ... on Product {
          id
          anySimilarProductAvailable
        }
      }
    }
  }
`;

interface CheckSimilarProductsAvailableData {
  viewer: {
    product: {
      id: string;
      anySimilarProductAvailable: boolean;
    };
  };
}

interface CheckSimilarProductsAvailableVariables {
  productId: string;
}

const useCheckSimilarProductsAvailableQuery = (
  options: QueryHookOptions<
    CheckSimilarProductsAvailableData,
    CheckSimilarProductsAvailableVariables
  >
) => {
  return useQuery<CheckSimilarProductsAvailableData, CheckSimilarProductsAvailableVariables>(
    CheckSimilarProductsAvailable_Emerson_Query,
    options
  );
};

export type { CheckSimilarProductsAvailableData };
/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useCheckSimilarProductsAvailableQuery, CheckSimilarProductsAvailable_Emerson_Query };
